var $71e167d2458a6019$exports = {};
$71e167d2458a6019$exports = {
  "decrease": function decrease(args) {
    return "Minska ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\xD6ka ".concat(args.fieldLabel);
  },
  "numberField": "Nummerf\xE4lt"
};
export { $71e167d2458a6019$exports as default };